import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {IContent} from '../../administration/contents/contents';
import {Auth} from '../../auth/auth.service';
import {MessengerService} from '../../messenger/messenger.service';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';
import {ArticleService} from '../services/article.service';

@Component({
    selector: 'kkk-article-item',
    templateUrl: './article-item.component.html'
})
export class ArticleItemComponent implements OnInit {
    article: IContent;

    constructor(
        private _service: ArticleService,
        private _route: ActivatedRoute,
        private _breadcrumbs: BreadcrumbsService,
        public auth: Auth,
        private _messenger: MessengerService,
    ) {
    }

    ngOnInit() {
        this._breadcrumbs.start({name: 'Tartalmak', instructions: ['/tartalmak']}).add({name: 'Hírek', instructions: ['/hirek']});
        this._route.params.subscribe(
            params => {
                this.loadArticle(params['id']);
            }
        );
    }

    private loadArticle(articleId: number) {
        this._service.fetch(articleId).subscribe(
            article => {
                this.article = article;
                this._breadcrumbs.add({name: article.title});
            },
            this._messenger.handleError
        );
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/contents/article-item/article-item.component.ts